module.exports = __webpack_public_path__ + "img/empty.6ae51fd1.jpg";